import { useSetRecoilState } from "recoil";
import {
  inventoryEntryPartIdState,
  inventoryItemAdditionalState,
  inventoryModalTitleState,
} from "../../utils/atoms/atoms";

interface IInventoryHistoryButton {
  modalId: string;
  modalTitle: string;
  identifierId?: number; // Optional prop for future use
  additionalInfo?: boolean; // Optional prop for additional info modal
}

const InventoryHistoryButton = ({
  modalId,
  modalTitle,
  identifierId,
  additionalInfo = false, // Optional prop for additional info modal
}: IInventoryHistoryButton) => {
  const setInventoryModalTitle = useSetRecoilState(inventoryModalTitleState);
  const setEntryPartId = useSetRecoilState(inventoryEntryPartIdState);
  const setInventoryAdditionalId = useSetRecoilState(
    inventoryItemAdditionalState
  );

  return (
    <button
      className="styled-btn--dark"
      data-bs-toggle="modal"
      data-bs-target={modalId}
      onClick={() => {
        if (additionalInfo) {
          setInventoryAdditionalId(identifierId || 0);
        } else {
          setEntryPartId(identifierId || 0); // Set to 0 if identifierId is not provided
        }
        setInventoryModalTitle(modalTitle);
      }}
    >
      {additionalInfo ? "Info" : "View"}
    </button>
  );
};

export default InventoryHistoryButton;
